











































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import LoadingCursor from '@components/LoadingCursor'
import Modal from '@/components/Modal'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'

settings =
  name: 'SamplingSpaceEditWizard'

  resources:
    space:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/spaces/:spaceId/edit'

    supplier_media_kit:
      resourceName: 'supplier_media_kit'
      slug: 'suppliers/:supplierId/media_kit'

    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:supplierId/audience_availabilities'

  vue:
    props: ['options']
    mixins: [WizardService.wizard()]

    components: {
      LoadingIndicator,
      LoadingCursor,
      Modal,
    }

    data: ->
      mode: 'EDIT'
      closeModal:
        show: false

    computed:
      member: -> @$store.member
      supplierId: -> @options?.supplierId || @member.supplier.id
      spaceId: -> @$route.params.spaceId
      spaceData: -> @prime.space
      spaceErrors: -> @formErrors.space || {}

      wizardRoutes: -> WizardRoutes
      routeQuery: -> @$route.query

      spaceAvailabilities: ->
        @prime.space?.availabilities || []

      mediaKits: ->
        supplier: @supplier_media_kit

    methods:
      hiClose: ->
        @closeModal.show = true

      hiConfirmClose: ->
        @$router.push({ name: 'SpaceListPage' })

      finish: ->
        @hiConfirmClose()

      save: ->
        clearTimeout(@time)
        @time = setTimeout(() =>
          @saveItem('prime.space')
        , 300)

      saveField: (fieldName) ->
        @saveItemField 'prime.space', fieldName

      fetchSpace: ->
        @fetch 'space'

      onSave: (item) ->
        @fetchSpace()

      fetchMediaKits: ->
        @fetch 'supplier_media_kit'

      bindAvailabilitiesToSpaceTrigger: (availabilities) ->
        payload =
          availability_ids: availabilities.map((a) => a.id)
        @triggerResource 'space', 'bind_availabilities', payload
      onSpaceBindAvailabilities: ->
        @fetchSpace()

      unbindAvailabilitiesToSpaceTrigger: (availabilities) ->
        payload =
          availability_ids: availabilities.map((a) => a.id)
        @triggerResource 'space', 'unbind_availabilities', payload
      onSpaceUnbindAvailabilities: ->
        @fetchSpace()

      setCapacityTrigger: (availability_ids, capacity) ->
        payload = { availability_ids, capacity }
        @triggerResource 'availabilities', 'set_capacity', payload
      onAvailabilitiesSetCapacity: ->
        @fetchSpace()
        @fetch 'availabilities'

    watch:
      steps: ->
        @navToStepName @routeQuery.step, { skipSave: true } if @routeQuery.step?

      'wizard.activeStep.name': (step) ->
        return unless step and step isnt 'empty'
        @$router.push { query: { ...@routeQuery, step } }

      routeQuery: (query) ->
        @navToStepName query.step, { skipSave: true } if query.step?

export default VueOptions.vue settings
